import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function PriceSection({
  value = null,
  units = '/Mo',
  isSecondary = false,
  children,
}) {
  const valueIsNumber = typeof value === 'number'
  const price = value && valueIsNumber ? numeral(value).format('$0') : value
  const colorClass = isSecondary ? 'is-secondary text-light-grey' : 'is-primary'

  return (
    <div className={`pricing-plan__price-section ${colorClass}`}>
      <strong className="pricing-plan__price">{`${price || '- '}`}</strong>
      {price && valueIsNumber && <span className="pricing-plan__units">{units}</span>}
      {children}
    </div>
  )
}

PriceSection.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  units: PropTypes.string,
  isSecondary: PropTypes.bool,
}

export default PriceSection
